/** @typedef {import('@/types/models').InstalledPrintClient} InstalledPrintClient  */

import Segment from '@/app/users/tracking/segment.js'

const mixpanelOnly = {
  integrations: {
    Mixpanel: true,
    All: false,
  },
}

export default {
  /**
   * tracking call for navigation menu
   *
   * @param {string} buttonId
   */
  trackNavMenuItemClick(buttonId) {
    Segment.track('App - Settings Navigation - Menu Item Clicked ', { buttonId })
  },

  /**
   * tracking call for top menu
   *
   * @param {string} buttonId
   */
  trackTopMenuItemClick(buttonId) {
    Segment.track('App - Top Menu - Menu Item Clicked ', { buttonId })
  },

  /**
   * @param {boolean} isEnabled
   */
  trackBetaCommunityOptIn(isEnabled) {
    Segment.track('App - Beta Community - Opt In', { isEnabled })
  },

  trackBetaCommunityJoinClick() {
    Segment.track('App - Beta Community - Join Link Clicked')
  },

  /**
   * @param {InstalledPrintClient} installedPrintClient
   */
  printClientDownload(installedPrintClient) {
    Segment.track(
      'Print Client - Download',
      {
        'Installed app version': installedPrintClient.version,
        'Type': installedPrintClient.type,
        'Platform': installedPrintClient.platform,
      },
      mixpanelOnly,
    )
  },
}
